import {
  BUY_PRODUCT_FOR_DELIVERY,
  BUY_PRODUCT_FOR_DELIVERY_ERROR,
  BUY_PRODUCT_FOR_DELIVERY_SUCCESS,
  BUY_PRODUCT_FOR_STORAGE,
  BUY_PRODUCT_FOR_DELIVERY_LOADING_QUOTE,
  BUY_PRODUCT_FOR_STORAGE_ERROR,
  BUY_PRODUCT_FOR_STORAGE_STATE_CLEAR,
  BUY_PRODUCT_FOR_STORAGE_SUCCESS,
  FRACTIONAL_CONVERSION_SUBMIT,
  IRA_ENTRUST_WITHDRAW_SUBMIT,
  IRA_FEE_WITHDRAWAL_SUBMIT,
  UPDATE_ACH_DEPOSIT,
  UPDATE_ACH_DEPOSIT_ERROR,
  UPDATE_ACH_DEPOSIT_SUCCESS,
  UPDATE_CHECK_WITHDRAWAL,
  UPDATE_CHECK_WITHDRAWAL_ERROR,
  UPDATE_CHECK_WITHDRAWAL_SUCCESS,
  UPDATE_WIRE_WITHDRAWAL,
  UPDATE_WIRE_WITHDRAWAL_ERROR,
  UPDATE_WIRE_WITHDRAWAL_SUCCESS,
  VERIFY_BUY_FOR_DELIVERY,
  VERIFY_BUY_FOR_DELIVERY_SUCCESS,
  VERIFY_BUY_FOR_DELIVERY_ERROR,
  WITHDRAWAL_WIZARD_STATE_RESET,
  GET_QUOTES_FOR_BUY_STORAGE,
  GET_QUOTES_FOR_ORDER_DELIVERY_BUY,
  GET_QUOTES_FOR_ORDER_STORAGE_SUCCESS,
  GET_QUOTES_FOR_ORDER_STORAGE_ERROR,
  GET_QUOTES_STORAGE_EMPTY,
  GET_QUOTES_DELIVERY_EMPTY,
  EXECUTE_QUOTES_FOR_BUY_STORAGE,
  GET_QUOTES_FOR_SELL,
  GET_QUOTES_FOR_SELL_SUCCESS,
  GET_QUOTES_FOR_SELL_ERROR,
  GET_QUOTES_SELL_EMPTY,
  GET_QUOTES_FOR_SELL_FROM_HOME,
  GET_QUOTES_FOR_SELL_FROM_HOME_SUCCESS,
  GET_QUOTES_FOR_SELL_FROM_HOME_ERROR,
  EXECUTE_QUOTES_FOR_SELL_FROM_HOME,
  EXECUTE_QUOTES_FOR_SELL_FROM_HOME_SUCCESS,
  EXECUTE_QUOTES_FOR_SELL_FROM_HOME_ERROR,
  EXECUTE_QUOTES_FOR_SELL,
  EXECUTE_QUOTES_SELL_EMPTY,
  EXECUTE_QUOTES_FOR_SELL_SUCCESS,
  EXECUTE_QUOTES_FOR_SELL_ERROR,
  GET_LOCATIONS_PRICE,
  GET_LOCATIONS_PRICE_SUCCESS,
  GET_LOCATIONS_PRICE_ERROR,
  GET_SELL_FROM_HOME_HISTORY,
  GET_SELL_FROM_HOME_HISTORY_SUCCESS,
  GET_SELL_FROM_HOME_HISTORY_ERROR,
  GET_SELL_FROM_HOME_HISTORY_EMPTY,
  GET_SFH_IRS_REPORTING_REQUIRED,
  GET_SFH_IRS_REPORTING_REQUIRED_SUCCESS,
  GET_SFH_IRS_REPORTING_REQUIRED_ERROR,
  CANCEL_SELL_FROM_HOME,
  CANCEL_SELL_FROM_HOME_SUCCESS,
  CANCEL_SELL_FROM_HOME_ERROR,
  GET_SFH_PURCHASE_LABEL,
  GET_SFH_PURCHASE_LABEL_SUCCESS,
  GET_SFH_PURCHASE_LABEL_ERROR,
} from './orderActionConstants';

// buy for storage
export const buyProductForStorage = (payload) => ({
  type: BUY_PRODUCT_FOR_STORAGE,
  payload,
});

export const buyProductForStorageSuccess = (payload) => ({
  type: BUY_PRODUCT_FOR_STORAGE_SUCCESS,
  payload,
});

export const buyProductForStorageError = (payload) => ({
  type: BUY_PRODUCT_FOR_STORAGE_ERROR,
  payload,
});

export const clearBuyStorageSuccessState = () => ({
  type: BUY_PRODUCT_FOR_STORAGE_STATE_CLEAR,
});

// buy for delivery
export const buyProductForDelivery = (payload) => ({
  type: BUY_PRODUCT_FOR_DELIVERY,
  payload,
});

export const buyProductForDeliverySuccess = () => ({
  type: BUY_PRODUCT_FOR_DELIVERY_SUCCESS,
});

export const buyProductForDeliveryError = () => ({
  type: BUY_PRODUCT_FOR_DELIVERY_ERROR,
});

export const startLoadingQuote = () => ({
  type: BUY_PRODUCT_FOR_DELIVERY_LOADING_QUOTE.START,
});

export const stopLoadingQuote = () => ({
  type: BUY_PRODUCT_FOR_DELIVERY_LOADING_QUOTE.STOP,
});

// fractional conversion
export const fractionalConversionSubmit = (payload) => ({
  type: FRACTIONAL_CONVERSION_SUBMIT,
  payload,
});

// ira entrust withdraw
export const iraEntrustWithdrawSubmit = (payload) => ({
  type: IRA_ENTRUST_WITHDRAW_SUBMIT,
  payload,
});

// ira fee withdrawal submit
export const iraFeeWithdrawalSubmit = (payload) => ({
  type: IRA_FEE_WITHDRAWAL_SUBMIT,
  payload,
});

export const updateAchDeposit = (payload) => ({
  type: UPDATE_ACH_DEPOSIT,
  payload,
});

export const updateAchDepositSuccess = (payload) => ({
  type: UPDATE_ACH_DEPOSIT_SUCCESS,
  payload,
});

export const updateAchDepositError = (payload) => ({
  type: UPDATE_ACH_DEPOSIT_ERROR,
  payload,
});

export const updateWireWithdrawal = (payload) => ({
  type: UPDATE_WIRE_WITHDRAWAL,
  payload,
});

export const updateWireWithdrawalSuccess = (payload) => ({
  type: UPDATE_WIRE_WITHDRAWAL_SUCCESS,
  payload,
});

export const updateWireWithdrawalError = (payload) => ({
  type: UPDATE_WIRE_WITHDRAWAL_ERROR,
  payload,
});

export const updateCheckWithdrawal = (payload) => ({
  type: UPDATE_CHECK_WITHDRAWAL,
  payload,
});

export const updateCheckWithdrawalSuccess = (payload) => ({
  type: UPDATE_CHECK_WITHDRAWAL_SUCCESS,
  payload,
});

export const updateCheckWithdrawalError = (payload) => ({
  type: UPDATE_CHECK_WITHDRAWAL_ERROR,
  payload,
});

export const standardWithdrawalWizardStateReset = () => ({
  type: WITHDRAWAL_WIZARD_STATE_RESET,
});

export const verifyBuyForDelivery = (payload) => ({
  type: VERIFY_BUY_FOR_DELIVERY,
  payload,
});

export const verifyBuyForDeliverySuccess = (payload) => ({
  type: VERIFY_BUY_FOR_DELIVERY_SUCCESS,
  payload,
});

export const verifyBuyForDeliveryError = (payload) => ({
  type: VERIFY_BUY_FOR_DELIVERY_ERROR,
  payload,
});

export const getQuotesForOrderStorageBuy = (payload) => ({
  type: GET_QUOTES_FOR_BUY_STORAGE,
  payload,
});

export const getQuotesForOrderStorageBuySuccess = (payload) => ({
  type: GET_QUOTES_FOR_ORDER_STORAGE_SUCCESS,
  payload,
});

export const getQuotesFoOrderStorageBuyError = (payload) => ({
  type: GET_QUOTES_FOR_ORDER_STORAGE_ERROR,
  payload,
});

export const emptyQuotesOrderStorageBuy = () => ({
  type: GET_QUOTES_STORAGE_EMPTY,
});

export const executeQuotesForOrderStorageBuy = (payload) => ({
  type: EXECUTE_QUOTES_FOR_BUY_STORAGE,
  payload,
});

export const executeQuotesForBuyStorageSuccess = (payload) => ({
  type: GET_QUOTES_FOR_ORDER_STORAGE_SUCCESS,
  payload,
});

export const executeQuotesFoBuyStorageError = (payload) => ({
  type: GET_QUOTES_FOR_ORDER_STORAGE_ERROR,
  payload,
});

export const emptyExecuteQuotesOrderStorageBuy = () => ({
  type: GET_QUOTES_STORAGE_EMPTY,
});

export const getQuotesForBuyDelivery = (payload) => ({
  type: GET_QUOTES_FOR_ORDER_DELIVERY_BUY,
  payload,
});

export const getQuotesForOrderDeliveryBuySuccess = (payload) => ({
  type: GET_QUOTES_FOR_ORDER_STORAGE_SUCCESS,
  payload,
});

export const getQuotesFoOrderDeliveryBuyError = (payload) => ({
  type: GET_QUOTES_FOR_ORDER_STORAGE_ERROR,
  payload,
});

export const emptyQuotesBuyOrderDelivery = () => ({
  type: GET_QUOTES_DELIVERY_EMPTY,
});

export const getQuotesForOrderSell = (payload) => ({
  type: GET_QUOTES_FOR_SELL,
  payload,
});

export const getQuotesForSellSuccess = (payload) => ({
  type: GET_QUOTES_FOR_SELL_SUCCESS,
  payload,
});

export const getQuotesForSellError = (payload) => ({
  type: GET_QUOTES_FOR_SELL_ERROR,
  payload,
});

export const getQuotesForOrderSellFromHome = (payload) => ({
  type: GET_QUOTES_FOR_SELL_FROM_HOME,
  payload,
});

export const getQuotesForSellFromHomeSuccess = (payload) => ({
  type: GET_QUOTES_FOR_SELL_FROM_HOME_SUCCESS,
  payload,
});

export const getQuotesForSellFromHomeError = (payload) => ({
  type: GET_QUOTES_FOR_SELL_FROM_HOME_ERROR,
  payload,
});

export const executeQuotesForOrderSellFromHome = (payload) => ({
  type: EXECUTE_QUOTES_FOR_SELL_FROM_HOME,
  payload,
});

export const executeQuotesForSellFromHomeSuccess = (payload) => ({
  type: EXECUTE_QUOTES_FOR_SELL_FROM_HOME_SUCCESS,
  payload,
});

export const executeQuotesForSellFromHomeError = (payload) => ({
  type: EXECUTE_QUOTES_FOR_SELL_FROM_HOME_ERROR,
  payload,
});

export const emptyQuotesSell = () => ({
  type: GET_QUOTES_SELL_EMPTY,
});

export const executeQuotesForOrderSell = (payload) => ({
  type: EXECUTE_QUOTES_FOR_SELL,
  payload,
});

export const executeQuotesForSellSuccess = (payload) => ({
  type: EXECUTE_QUOTES_FOR_SELL_SUCCESS,
  payload,
});

export const executeQuotesForSellError = (payload) => ({
  type: EXECUTE_QUOTES_FOR_SELL_ERROR,
  payload,
});

export const emptyExecuteQuotesSell = () => ({
  type: EXECUTE_QUOTES_SELL_EMPTY,
});

// get location price
export const getPriceForLocation = (payload) => ({
  type: GET_LOCATIONS_PRICE,
  payload,
});

export const getPriceForLocationSuccess = (payload) => ({
  type: GET_LOCATIONS_PRICE_SUCCESS,
  payload,
});

export const getPriceForLocationError = (payload) => ({
  type: GET_LOCATIONS_PRICE_ERROR,
  payload,
});

// sell from home order history (view history screen)
export const getSellFromHomeHistory = (payload) => ({
  type: GET_SELL_FROM_HOME_HISTORY,
  payload,
});

export const getSellFromHomeHistorySuccess = (payload) => ({
  type: GET_SELL_FROM_HOME_HISTORY_SUCCESS,
  payload,
});

export const getSellFromHomeHistoryError = (payload) => ({
  type: GET_SELL_FROM_HOME_HISTORY_ERROR,
  payload,
});

export const emptySellFromHomeHistory = () => ({
  type: GET_SELL_FROM_HOME_HISTORY_EMPTY,
});

// SFH IRS reporting check (gates Continue to Shipping -> SSN drawer)
export const getSfhIrsReportingRequired = (payload) => ({
  type: GET_SFH_IRS_REPORTING_REQUIRED,
  payload,
});

export const getSfhIrsReportingRequiredSuccess = (payload) => ({
  type: GET_SFH_IRS_REPORTING_REQUIRED_SUCCESS,
  payload,
});

export const getSfhIrsReportingRequiredError = (payload) => ({
  type: GET_SFH_IRS_REPORTING_REQUIRED_ERROR,
  payload,
});

// cancel a sell from home order (cancel request confirmation)
export const cancelSellFromHomeOrder = (payload) => ({
  type: CANCEL_SELL_FROM_HOME,
  payload,
});

export const cancelSellFromHomeOrderSuccess = (payload) => ({
  type: CANCEL_SELL_FROM_HOME_SUCCESS,
  payload,
});

export const cancelSellFromHomeOrderError = (payload) => ({
  type: CANCEL_SELL_FROM_HOME_ERROR,
  payload,
});

// fetch the shipping (purchase) label PDF URLs for a sell from home order
export const getSfhPurchaseLabel = (payload) => ({
  type: GET_SFH_PURCHASE_LABEL,
  payload,
});

export const getSfhPurchaseLabelSuccess = (payload) => ({
  type: GET_SFH_PURCHASE_LABEL_SUCCESS,
  payload,
});

export const getSfhPurchaseLabelError = (payload) => ({
  type: GET_SFH_PURCHASE_LABEL_ERROR,
  payload,
});
